const BASE = '/api';

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const r = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...init,
  });
  const body = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error((body as { erro?: string })?.erro || `HTTP ${r.status}`);
  return body as T;
}

export interface Produto {
  id: number;
  nome: string;
  categoria: string | null;
  preco: number;
  unidade: string;
  estoque: number;
  estoque_minimo: number;
  ativo: boolean;
  baixo: boolean;
  criado_em: string;
  atualizado_em: string;
}

export interface NovoProdutoInput {
  nome: string;
  categoria?: string | null;
  preco?: number;
  unidade?: string;
  estoque?: number;
  estoque_minimo?: number;
}

export interface AtualizarProdutoInput {
  nome?: string;
  categoria?: string | null;
  preco?: number;
  unidade?: string;
  estoque_minimo?: number;
  ativo?: boolean;
}

export async function listarProdutos(opts?: { ativo?: boolean; baixo?: boolean }): Promise<Produto[]> {
  const q = new URLSearchParams();
  if (opts?.ativo) q.set('ativo', '1');
  if (opts?.baixo) q.set('baixo', '1');
  const qs = q.toString();
  const r = await req<{ ok: boolean; produtos: Produto[] }>(`/produtos${qs ? `?${qs}` : ''}`);
  return r.produtos;
}

export async function criarProduto(input: NovoProdutoInput): Promise<Produto> {
  const r = await req<{ ok: boolean; produto: Produto }>(`/produtos`, {
    method: 'POST',
    body: JSON.stringify(input),
  });
  return r.produto;
}

export async function atualizarProduto(id: number, input: AtualizarProdutoInput): Promise<Produto> {
  const r = await req<{ ok: boolean; produto: Produto }>(`/produtos/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
  return r.produto;
}

export async function ajustarEstoque(id: number, delta: number, motivo?: string): Promise<Produto> {
  const r = await req<{ ok: boolean; produto: Produto }>(`/produtos/${id}/estoque`, {
    method: 'POST',
    body: JSON.stringify({ delta, motivo }),
  });
  return r.produto;
}

export async function desativarProduto(id: number): Promise<Produto> {
  const r = await req<{ ok: boolean; produto: Produto }>(`/produtos/${id}`, { method: 'DELETE' });
  return r.produto;
}
